import Clarity from "@microsoft/clarity";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import "cal-sans";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

import { ErrorComponent } from "./components/error";
import { NotFoundComponent } from "./components/not-found";
import { envVars } from "./lib/env/schema";
import { routeTree } from "./routeTree.gen";

const queryClient = new QueryClient();

// Create a new router instance
const router = createRouter({
	routeTree,
	context: { queryClient },
	defaultPreloadStaleTime: 0,
	defaultErrorComponent: ErrorComponent,
	defaultNotFoundComponent: NotFoundComponent,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

// Render the app
const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("Root element not found");
}

const projectId = envVars.VITE_CLARITY_PROJECT_ID;
Clarity.init(projectId);

const root = createRoot(rootElement);
root.render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
		</QueryClientProvider>
	</StrictMode>,
);
